import * as React from 'react'
import { useCallback } from 'react'

import { SideDrawer } from '@sales-center/components'
import type { SoldServicesDrawerProps } from './typings'
import { SoldServicesContent } from './SoldServicesContent'
import {
  useCWQDialogContext,
  closeDialogActionCreator as closeDialog,
} from '@user/components/SoldServices'

export function SoldServicesDrawer(props: SoldServicesDrawerProps) {
  const [{ activeDialog }, dispatch] = useCWQDialogContext()

  const open = activeDialog === 'ssq'

  const onCancel = useCallback(() => dispatch(closeDialog()), [dispatch])

  return (
    <SideDrawer open={open} onClose={onCancel} title="Close / Win Opportunity">
      <SoldServicesContent {...props} />
    </SideDrawer>
  )
}
